import React from "react";
import {
  Card,
  Typography,
  Space,
  Button,
  Input,
  Form,
  Spin,
  Alert,
} from "antd";
import { UserOutlined, SearchOutlined } from "@ant-design/icons";
import type { FormInstance } from "antd/es/form";

const { Paragraph } = Typography;

interface BotResolveStepProps {
  form: FormInstance<{ email?: string; phone?: string }>;
  loading: boolean;
  searched: boolean;
  hasResults: boolean;
  onSearch: () => void;
}

export const BotResolveStep: React.FC<BotResolveStepProps> = ({
  form,
  loading,
  searched,
  hasResults,
  onSearch,
}) => (
  <Card
    title={
      <Space>
        <UserOutlined />
        <span>Step 1 — Resolve identity</span>
      </Space>
    }
    style={{ marginBottom: 24 }}
  >
    <Paragraph type="secondary">
      Enter the channel identifier (Gmail address or WhatsApp number). We look
      up matching companies via invoice email, company phone, and linked portal
      users.
    </Paragraph>
    <Form
      form={form}
      layout="vertical"
      onFinish={onSearch}
      initialValues={{ email: "", phone: "" }}
    >
      <Form.Item
        name="email"
        label="Email"
        rules={[{ type: "email", message: "Enter a valid email" }]}
      >
        <Input
          placeholder="user@company.com"
          allowClear
          autoComplete="off"
        />
      </Form.Item>
      <Form.Item name="phone" label="Phone number">
        <Input
          placeholder="+31 6 12 34 56 78"
          allowClear
          autoComplete="off"
        />
      </Form.Item>
      <Button
        type="primary"
        htmlType="submit"
        icon={<SearchOutlined />}
        loading={loading}
      >
        Run resolve
      </Button>
    </Form>

    {loading && (
      <div style={{ textAlign: "center", padding: 32 }}>
        <Spin />
      </div>
    )}

    {!loading && searched && !hasResults && (
      <Alert
        style={{ marginTop: 16 }}
        type="info"
        showIcon
        message="No matches"
        description="No company matched this email or phone."
      />
    )}
  </Card>
);
